<template>
  <div class="ui-content dashboard">
    <div class="cumulative-back-button" v-if="showCumulativeButton()">
      <v-btn
        depressed
        color="indigo"
        @click="gotoCumulativeAnalysis()"
        class="cumulative-btn"
      >
        Cumulative Analysis
      </v-btn>
    </div>
    <div class="page-user user">
      <v-tabs
        v-model="tab"
        background-color
        class="elevation-2 cust-tab"
        @change="updateBreadCrumbs"
      >
        <v-tabs-slider></v-tabs-slider>
        <v-tab key="1" :href="'#Response Analysis'">Response Analysis</v-tab>
        <v-tab key="2" :href="'#Time Analysis'">Time Analysis</v-tab>
        <v-tabs-items :touchless="true" v-model="tab">
          <v-tab-item key="1" :value="'Response Analysis'">
            <v-card class="mx-auto normal-card">
              <ResponseA />
            </v-card>
          </v-tab-item>
          <v-tab-item key="2" :value="'Time Analysis'">
            <v-card class="mx-auto normal-card">
              <TimeAnalysis />
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-tabs>
    </div>
  </div>
</template>

<script>
import ResponseA from "@/components/student/ResponseA.vue";
import TimeAnalysis from "@/components/student/TimeAnalysis.vue";
import { mapMutations, mapState } from "vuex";
import constants from "@/utils/constants.js";

export default {
  name: "ResponseAnalysis",
  components: {
    ResponseA,
    TimeAnalysis,
  },
  mounted() {
    this.checkSessionData();
  },
  data() {
    return {
      tab: null,
    };
  },
  methods: {
    ...mapMutations("app", ["addBreadCrumbChilde"]),
    defaultData() {
      let routeName = this.$route.name;
      let crd = this.getCurrentRouteDetails(routeName);
      if (crd) {
        this.tab = crd.selectedTab ? crd.selectedTab : "Response Analysis";
      }
    },
    gotoCumulativeAnalysis() {
      let routeName = "cumulative-analysis-coordinator"
	// 	if(this.$route.name === "testwise-analysis-coordinator"){
	// 	   routeName = "cumulative-analysis-coordinator"
	//    }
	   if(this.$route.name ==="response-analysis-director"){
		   routeName ="cumulative-analysis-director"
	   }
      this.$router.push({
        name: routeName,
        params: { ...this.$route.params, resetPage: true, isCD: true },
      });
    },
    showCumulativeButton() {
      let user = JSON.parse(sessionStorage.getItem("user"));
      return (
        user &&
        (user.role_id === constants.ROLES_ID.ID ||
          user.role_id === constants.ROLES_ID.CO ||
          user.role_id === constants.ROLES_ID.TR)
      );
    },
    checkSessionData() {
      let rp = this.$route; // route params
      let crd = this.getCurrentRouteDetails(rp.name);

      if (rp.params.resetPage || !crd.routeName) {
        let routeDetails = {
          routeName: rp.name,
          selectedTab: crd.selectedTab ? crd.selectedTab : "Response Analysis",
        };
        this.setRouteDetails(routeDetails);
      }
      this.defaultData();
      this.updateBreadCrumbs();
    },
    updateBreadCrumbs() {
      let user = JSON.parse(sessionStorage.getItem("user"));
      const userData = JSON.parse(sessionStorage.getItem("user-detail"));
      let testName = this.$route.params.test_name;
      let selectedTestType = this.$route.params.selectedTestType == "premium" ? "Ready-made Tests" : this.$route.params.selectedTestType == "self" ? "Self-made Tests" : this.$route.params.selectedTestType == "institute" ? "Institute Tests" : '';
      let breadCrumbs = [];
      if (
        this.roleIds.CO === this.user.role_id ||
        this.roleIds.ID === this.user.role_id
      ) {
        let studentName = sessionStorage.getItem("studentName");
        if (studentName && this.$route.name !=  "response-analysis-coordinator") {
          studentName = JSON.parse(studentName);
          //breadCrumbs.push({ text: studentName.studentName, disabled: false });
        }
      }
	  let routeName = "testwise-analysis-coordinator"
	  if(this.$route.name ===  "response-analysis-coordinator"){
		   routeName = "testwise-analysis-coordinator"
	   }
	    else if(this.$route.name ==="response-analysis-director"){
		   routeName ="testwise-analysis-director"
	   }
     if(this.roleIds.ID === this.user.role_id || this.roleIds.CO === this.user.role_id) {breadCrumbs.push({
        text:userData && userData.name ?userData.name:user.name,
        disabled: false,
        to: {
          name: routeName,
          params: {
            student_id:userData && userData.id ?userData.id: null,
            batch_id: userData && userData.batch_id ?userData.batch_id  : null,
            name:userData && userData.name ?userData.name : null,
            resetPage: true,
            isCD: true,
          },
        },
     });}
     if(selectedTestType && (this.roleIds.ST === this.user.role_id || this.roleIds.PA === this.user.role_id)) {
      breadCrumbs.push({ text: selectedTestType, disabled: false });
     }
      breadCrumbs.push({ text: testName, disabled: false });
      breadCrumbs.push({ text: this.tab, disabled: false });

      this.addBreadCrumbChilde(breadCrumbs);
    },
  },
  computed: {
    ...mapState("userStore", ["user"]),
  },
  watch: {
    tab(val, oldVal) {
      if (oldVal) {
        // only when tab is changed and not on page load
        let routeName = this.$route.name;
        this.setRouteDetails({ routeName, selectedTab: val });
      }
    },
  },
};
</script>